import { de, enUS, es, fr, ja, ko } from 'date-fns/locale';

export const locales = new Map(
  Object.entries({
    'de-DE': de,
    'en-US': enUS,
    'es-LA': es,
    'fr-FR': fr,
    'ja-JP': ja,
    'ko-KR': ko,
  }),
);
